import React from 'react';

const FinancialMarketMono = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.49 20.78L41.5 23.5L46.5 16.5"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2.5 24.5L6.5 27.5L10.5 20.5L16.5 31.5L20.5 23.5L24.5 26.5L28.678 21.683"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M46.5 5.5H2.5V43.5H46.5V5.5Z"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M32.5 29.5V43.5"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M32.5 5.5V16.5"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M32.5 24.5C34.7091 24.5 36.5 22.7091 36.5 20.5C36.5 18.2909 34.7091 16.5 32.5 16.5C30.2909 16.5 28.5 18.2909 28.5 20.5C28.5 22.7091 30.2909 24.5 32.5 24.5Z"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export default FinancialMarketMono;
